import { useState, useCallback, useMemo } from 'react';
import api from '../services/api.js';
import toast from 'react-hot-toast';

export const TIPOS_CONTRATO = [
  'TODOS',
  'Constitución',
  'Modificación',
  'Transformación',
  'Disolución',
];

export function useIndiceSociedades() {
  const [nombreBusqueda, setNombreBusqueda] = useState('');
  const [tipoContratoFiltro, setTipoContratoFiltro] = useState('TODOS');
  const [inscripciones, setInscripciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [haBuscado, setHaBuscado] = useState(false);

  const consultarSociedad = useCallback(async (nombre = nombreBusqueda, tipo = tipoContratoFiltro) => {
    const query = (nombre ?? '').trim();
    if (!query || query.length < 2) {
      toast.error('Ingresa al menos 2 caracteres para el nombre de la sociedad.');
      return;
    }

    setCargando(true);
    setError(null);
    setHaBuscado(true);

    try {
      const params = { nombre_de_la_sociedad: query };
      if (tipo && tipo !== 'TODOS') {
        params.tipo_de_contrato = tipo;
      }

      const res = await api.get('/indices/sociedades', { params });

      if (res.data?.success) {
        setInscripciones(res.data.data || []);
      } else {
        setInscripciones([]);
      }
    } catch (err) {
      console.error('Error al consultar índice de sociedades:', err);
      const msg = err.response?.data?.message || 'Error al conectar con el servidor de Índices.';
      setError(msg);
      toast.error(msg);
      setInscripciones([]);
    } finally {
      setCargando(false);
    }
  }, [nombreBusqueda, tipoContratoFiltro]);

  const limpiar = useCallback(() => {
    setNombreBusqueda('');
    setTipoContratoFiltro('TODOS');
    setInscripciones([]);
    setError(null);
    setHaBuscado(false);
  }, []);

  // Conteo de inscripciones agrupadas por tipo de contrato
  const conteoPorTipo = useMemo(() => {
    return inscripciones.reduce((acc, curr) => {
      const tipo = curr.tipo_de_contrato_categoria || curr.tipo_de_contrato || 'Otro';
      acc[tipo] = (acc[tipo] || 0) + 1;
      return acc;
    }, {});
  }, [inscripciones]);

  return {
    nombreBusqueda,
    setNombreBusqueda,
    tipoContratoFiltro,
    setTipoContratoFiltro,
    inscripciones,
    cargando,
    error,
    haBuscado,
    conteoPorTipo,
    consultarSociedad,
    limpiar,
  };
}
